import { render, staticRenderFns } from "./CommissionListDetail.vue?vue&type=template&id=b4a0e740&scoped=true"
import script from "./CommissionListDetail.vue?vue&type=script&lang=js"
export * from "./CommissionListDetail.vue?vue&type=script&lang=js"
import style0 from "./CommissionListDetail.vue?vue&type=style&index=0&id=b4a0e740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a0e740",
  null
  
)

export default component.exports